import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PARK_DOCUMENT } from "./apiRoutes";

interface UseGetParkDocByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getParkDocById = async (id: string) =>
  await axiosAuth.get(`${PARK_DOCUMENT}/park/${id}`);

const useGetParkDocumentById = ({
  id,
  queryParams,
}: UseGetParkDocByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["park-document", id],
    queryFn: () => getParkDocById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetParkDocumentById;
